import urlCreator from '../../../utils/urlCreator';
import { getData } from '../../../utils/http';
import Optional from '../../../utils/optional';
import RESPONSE_CODES from '../../../consts/responseCodes';
import { URLS } from '../../../consts/endpoints';

export default async function getCount({ url, selectedClientId }) {
  const QUERY_PARAMS = {
    page: { size: 0 },
    filter: { client_id: { eq: selectedClientId } },
    stats: { total: 'count' }
  };

  try {
    const { data: response } = await getData({
      options: { url: urlCreator(url, QUERY_PARAMS) },
      errorsToPass: [RESPONSE_CODES.NOT_FOUND]
    });

    const count = Optional(response?.meta?.stats?.total?.count).or(0);

    return count;
  } catch (e) {
    console.error(e);
  }
}

export const getIoTQueryCount = async ({ selectedClientId }) => {
  const QUERY_PARAMS = {
    page: { size: 1 },
    product_category: 'IoT',
    execute_fetch_events: false,
    return_projections: false
  };

  const response = await getData({
    options: {
      url: urlCreator(
        `${URLS.QUOTE_CLIENTS}/${selectedClientId}/subscriptions`,
        QUERY_PARAMS
      )
    }
  });

  return Number(Optional(response?.headers?.['x-total-count']).or(0));
};
